// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__29hT1","title":"Header_title__39Y1k","side":"Header_side__zjYuD"};